const { AI_CREDITS_USAGE_PER } = require("../../constants/cookies");
const { SEAT, ACCOUNT } = AI_CREDITS_USAGE_PER;
// Pure decision for sticky seat vs account. Callers write the cookie / fire
// enter-test only when `shouldAllocate` is true (first assignment).
const resolveCreditsPerSeat = ({ existingValue = null, simulateCreditsPerSeatTest = false, abVariant = null } = {})=>{
    if (existingValue === SEAT) {
        return {
            enabled: true,
            shouldAllocate: false
        };
    }
    if (existingValue === ACCOUNT) {
        return {
            enabled: false,
            shouldAllocate: false
        };
    }
    if (simulateCreditsPerSeatTest) {
        return {
            enabled: true,
            shouldAllocate: true,
            allocateValue: SEAT
        };
    }
    if (abVariant == null) {
        return {
            enabled: false,
            shouldAllocate: false
        };
    }
    if (abVariant === true) {
        return {
            enabled: true,
            shouldAllocate: true,
            allocateValue: SEAT
        };
    }
    return {
        enabled: false,
        shouldAllocate: true,
        allocateValue: ACCOUNT
    };
};
module.exports = {
    resolveCreditsPerSeat
};
